// extracted by mini-css-extract-plugin
module.exports = {"w1ewzjmv":"w1ewzjmv","s132djyi":"s132djyi","bubbleIn-s132djyi":"bubbleIn-s132djyi"};